// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import { menuPanelRowResetStyles, menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: css`
                max-height: none;
            `,
        },
        headerColor: "common.background",
        bodyColor: "common.background",
        childTypographyProps: {
            color: "text",
            css: css`
                font-weight: ${({ theme }) => theme.design.typography.weight.bold};
                font-size: ${({ theme }) => theme.design.typography.size.large};
            `,
        },
        panelRowProps: {
            color: "common.shadesLight",
            moreIconProps: {
                css: css`
                    color: ${getColor("primary")};
                `,
            },
            css: css`
                width: 100%;
                padding: ${x => x.theme.design.layout.spacing.small};

                &:hover * {
                    color: ${getColor("secondary")};
                }

                &:focus,
                &:active {
                    background-color: ${getColor("common.accent")};
                    outline-offset: ${pxToRem(-2)};
                }
            `,
            // Theme doesn't work here. Needs to be investigated
            isCurrentCss: css`
                background-color: #f3f5f7; /* common.accent color */

                [class*="TypographyStyle"] {
                    font-weight: 700; /* theme.design.typography.weight.bold */
                }
            `,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeIconProps: menuPanelProps.closeButtonIcon,
        parentPanelRowProps: {
            css: menuPanelRowResetStyles(),
        },
        parentLinkProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "menu.mainNavigation.accent",
                    hoverColor: "menu.mainNavigation.accentHover",
                })}

                flex: 0 0 0%;
                white-space: nowrap;
                padding-left: 0;
            `,
        },
        backIconProps: {
            src: ChevronLeft,
            color: "primary",
        },
        parentTypographyProps: { ellipsis: true },
    },
};

export default panelMenu;
